import { signalStoreFeature, withMethods, withProps } from '@ngrx/signals';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export const withSnackBarFeature = () =>
  signalStoreFeature(
    withProps(() => ({
      _snackBar: inject(MatSnackBar),
    })),
    withMethods(({ _snackBar }) => {
      const _snackBarMessage = (
        message: string,
        action = '',
        duration: number,
        panelClass?: string,
      ) => {
        _snackBar.open(message, action, {
          duration,
          horizontalPosition: 'start',
          verticalPosition: 'bottom',
          ...(panelClass ? { panelClass } : {}),
        });
      };
      return {
        displaySnackBar: (
          message: string,
          action = '',
          duration = 5000,
          panelClass?: string,
        ) => _snackBarMessage(message, action, duration, panelClass),
      };
    }),
  );
